import { Component, OnInit, ViewChild } from '@angular/core';
import { Worklog } from '../../worklogs.model';
import { ObjectToSelect } from '../../../core/shared/objectToSelect.model';
import { NumeratorComponent } from '../../../numerator/numerator.component';
import { NgForm } from '@angular/forms';
import { WorklogsRest } from '../../worklogs.rest';
import { DateInputModel } from '../../../core/shared/date-input/date-input.model';
import { NumeratorType } from '../../../numerator/numerator.model';
import { NgxSelectOption, INgxSelectOption } from 'ngx-select-ex';
import { ProjectsRest } from '../../../projects/projects.rest';
import { IssuesRest } from '../../../issues/issues.rest';
import { CustomersRest } from '../../../company/customers/customers.rest';
import { CustomerRow } from '../../../company/customers/customers.model';
import { IssueRow, Issue } from '../../../issues/issues.model';
import { SelectionMode } from '../../../core/shared/grid/grid.model';
import { CustomersListComponent } from '../../../company/customers/customers-list/customers-list.component';
import { IssuesListComponent } from '../../../issues/issues-list/issues-list.component';
import { SpinEditComponent } from '../../../core/shared/spinedit/spinedit.component';
import { Permissions } from '../../../core/services/permissions/permissions.model';
import { LoginRest } from '../../../login/login.rest';
import { DialogService } from '../../../core/shared/dialog/dialog.service';
import { DialogConfig } from '../../../core/shared/dialog/dialog-config';

const workDateInternalName: string = 'WorkDate';

@Component({
  selector: 'app-worklog-header',
  templateUrl: './worklog-header.component.html'
})
export class WorklogHeaderComponent implements OnInit {

  constructor(
    private rest: WorklogsRest,
    private projRest: ProjectsRest,
    private custRest: CustomersRest,
    private issueRest: IssuesRest,
    private dialog: DialogService,
    private loginRest: LoginRest) { }


  public employeesRows: ObjectToSelect[];
  public projectSteps: ObjectToSelect[];
  public workDate: DateInputModel;

  public isNew: boolean;
  public worklog: Worklog;

  private afterViewInit = false;
  public isValid: boolean = true;

  private oldProject: string;
  private oldCustomer: string;
  private oldPayer: string;
  private oldIssue: string;
  private fromIssue = false;

  permissions: Permissions;
  @ViewChild(NumeratorComponent) numeratorComponent: NumeratorComponent;
  @ViewChild('worklogForm') worklogForm: NgForm;
  @ViewChild('invoiceTime') invoiceTime: SpinEditComponent;
  @ViewChild('timeSpent') timeSpent: SpinEditComponent;

  ngOnInit() {
    //this.getEmployees();
  }

  private onElementValidation(element, isValid: boolean) {

    if (!element) {
      return;
    }

    if (element.internalName == workDateInternalName) {
      this.worklog.workDate = element.value;
    }
  }

  public setModel(worklog: Worklog, isNew: boolean, issue: Issue, permission: Permissions) {
    this.permissions = permission;
    this.worklog = worklog;

    this.isNew = isNew;
    if (issue !== null) {
      this.worklog.issueId = issue.id;
      this.worklog.issueName = issue.title;
      if (isNew) {
        this.worklog.customerId = issue.customerId;
        this.worklog.customerCode = issue.customerCode;
        this.worklog.payerId = issue.customerId;
        this.worklog.payerCode = issue.customerCode;
        this.worklog.projectStepId = issue.projectStepId;
        this.worklog.projectStepName = issue.projectStepName;
        this.worklog.reporterId = issue.reporterId;
        this.buildDescription();
      }
      this.fromIssue = true;
    }
    this.numeratorComponent.setModel(this.worklog, NumeratorType.worklog, 'Worklog');
    this.initializeDate();
    if (this.worklog.customerId) {
      this.getCustomerProjectSteps(this.worklog.customerId);
      this.getEmployees(this.worklog.customerId);
    } else {
      this.getEmployees(0);
    }
    if (!this.worklog.employeeId) {
      this.loginRest.GetLoggedUser().subscribe((user: any) => {
        this.worklog.employeeId = user.employeeId;
        this.worklog.employeeFullName = user.name;
      });
    }
    this.afterViewInit = true;
  }

  onKeyDownCustomer() {
    this.oldCustomer = this.worklog.customerCode;
  }

  public onKeyCustomer(event: any) {
    if (this.oldCustomer !== this.worklog.customerCode) {
      this.worklog.customerId = null;
      this.worklog.payerId = null;
      this.clearCustomerInfo();
    }
    if (event.key === 'Enter' || (event.key === undefined && event.returnValue === true)) {
      this.searchCustomer();
    }
  }

  onKeyDownPayer() {
    this.oldPayer = this.worklog.payerCode;
  }

  public onKeyPayer(event: any) {
    if (this.oldPayer !== this.worklog.payerCode) {
      this.worklog.payerId = null;
    }
    if (event.key === 'Enter' || (event.key === undefined && event.returnValue === true)) {
      this.searchPayer();
    }
  }

  // onKeyDownProject() {
  //   this.oldProject = this.worklog.projectStepName;
  // }
  // public onKeyProject(event: any) {
  //   if (this.oldProject !== this.worklog.projectStepName) {
  //     this.worklog.projectStepId = null;
  //   }
  //   if (event.key === 'Enter') {
  //     this.searchProject();
  //   }
  // }

  onKeyDownIssue() {
    this.oldIssue = this.worklog.issueName;
  }
  public onKeyIssue(event: any) {
    if (this.oldIssue !== this.worklog.issueName) {
      this.worklog.issueId = null;
    }
    if (event.key === 'Enter') {
      this.searchIssue();
    }
  }

  public biggerThanZero(controlValue: number) {
    return controlValue <= 0;
  }

  private getEmployees(customerId: number) {
    this.rest.getUsersRows(customerId).subscribe((result: ObjectToSelect[]) => {
      if (result) {
        let rows = result.sort((x, y) => x.name > y.name ? 1 : -1);
        this.employeesRows = rows;
        if (this.worklog && this.worklog.reporterId) {
          if (!rows.some(x => x.id === this.worklog.reporterId)) {
            this.worklog.reporterId = null;
          }
        }
        if (this.fromIssue && this.isNew && this.worklog && !this.worklog.description) {
          this.buildDescription();
        }
      }
    });
  }

  private initializeDate() {
    this.workDate = new DateInputModel();
    this.workDate.isReadOnly = !this.permissions.canEdit;
    this.workDate.isRequired = false;
    this.workDate.name = 'Data pracy';
    this.workDate.value = new Date(this.worklog.workDate);
    this.workDate.valueStr = this.workDate.value.toDateString();
    this.workDate.withTime = false;
    this.workDate.internalName = workDateInternalName;
  }

  public onTimeSpentChange(event: number) {
    this.worklog.timeSpent = event;
    if (this.invoiceTime) {
      this.worklog.invoiceTime = event;
    }
  }

  public onStartDateChange(element, isValid: boolean) {
    if (!element || !isValid) {
      return;
    }
    this.worklog.workDate = this.workDate.value;
    this.workDate.valueStr = this.workDate.value.toDateString();
  }

  private selectEmployeeFilter(value: NgxSelectOption[]) {
    let selectedValue = value[0] ? value[0].data : new ObjectToSelect();
    this.worklog.employeeId = selectedValue.id;
  }

  private selectReporterFilter(value: NgxSelectOption[]) {
    let selectedValue = value[0] ? value[0].data : new ObjectToSelect();
    this.worklog.reporterId = selectedValue.id;
  }

  // private searchProject() {
  //   if (this.worklog.customerId == null) {
  //     sweetAlert('Należy najpierw wybrać kontrahenta');
  //     return;
  //   }
  //   let data = {id: this.worklog.customerId  , value: this.worklog.projectStepName};
  //   this.projRest.getProjectByStepName(data).subscribe((result: ProjectRow[]) => {
  //     if (result.length == 1)  {
  //       let projectRow = result[0];
  //       this.worklog.projectStepName = projectRow.projectStepName;
  //       this.worklog.projectStepId = projectRow.id;

  //     } else {
  //       this.openProjectsModal();
  //     }
  //   });
  // }

  private searchCustomer() {
    if (this.worklog.customerCode === '') {
      this.worklog.customerCode = null;
    }

    this.custRest.getCustomerRowsByName(this.worklog.customerCode).subscribe((result: CustomerRow[]) => {
      if (result.length == 1) {
        let customer = result[0];
        this.worklog.customerId = customer.id;
        this.worklog.customerCode = customer.code;
        this.worklog.payerId = customer.id;
        this.worklog.payerCode = customer.code;
        // this.getCustomerProjectSteps(this.worklog.customerId);
        // this.getEmployees(customer.id);
        this.clearCustomerInfo();
      } else {
        this.openCustomerModal();
      }
    });
  }

  private searchPayer() {
    if (this.worklog.payerCode === '') {
      this.worklog.payerCode = null;
    }

    this.custRest.getCustomerRowsByName(this.worklog.payerCode).subscribe((result: CustomerRow[]) => {
      if (result.length == 1) {
        let payer = result[0];
        this.worklog.payerId = payer.id;
        this.worklog.payerCode = payer.code;
      } else {
        this.openPayerModal();
      }
    });
  }

  private clearCustomerInfo() {    
    this.worklog.projectStepId = null;
    this.worklog.projectStepName = '';
    this.worklog.issueId = null;
    this.worklog.issueName = '';
    
    if (this.worklog.customerId) {
      this.getCustomerProjectSteps(this.worklog.customerId);
      this.getEmployees(this.worklog.customerId);
    } else {      
      this.projectSteps = null;        
    }
  }

  private searchIssue() {
    if (this.worklog.customerId == null) {
      sweetAlert('Należy najpierw wybrać kontrahenta');
      return;
    }

    if (this.worklog.projectStepId == null) {
      sweetAlert('Należy najpierw wybrać projekt');
      return;
    }

    let data = { id: this.worklog.projectStepId, value: this.worklog.issueName };
    this.issueRest.getIssueRowsByFilter(data).subscribe((result: IssueRow[]) => {
      if (result.length == 1) {
        let issueRow = result[0];
        this.worklog.issueId = issueRow.id;
        this.worklog.issueName = issueRow.fullTitle;
      } else {
        this.openIssueModal();
      }
    });
  }

  public openCustomerModal() {
    let dialogConf = new DialogConfig();
    dialogConf.selectionMode = SelectionMode.single;
    dialogConf.title = 'Wybierz kontrahenta';
    dialogConf.maxwidth = '1050px';
    
    dialogConf.data = { selectList: true,  initialFilters: { code: this.worklog.customerCode } };
    const ref = this.dialog.open(CustomersListComponent, dialogConf);

    ref.afterClosed.subscribe((result: CustomerRow) => {
      if (result != null) {
        this.worklog.customerId = result.id;
        this.worklog.customerCode = result.code;
        this.worklog.payerId = result.id;
        this.worklog.payerCode = result.code;
        this.worklog.projectStepId = null;
        this.worklog.projectStepName = '';
        this.worklog.issueId = null;
        this.worklog.issueName = '';
        this.getCustomerProjectSteps(this.worklog.customerId);
        this.getEmployees(result.id);
      }
    });
  }

  public openPayerModal() {
    let dialogConf = new DialogConfig();
    dialogConf.selectionMode = SelectionMode.single;
    dialogConf.title = 'Wybierz płatnika';
    dialogConf.maxwidth = '1050px';
    
    dialogConf.data = { selectList: true,  initialFilters: { code: this.worklog.payerCode } };
    const ref = this.dialog.open(CustomersListComponent, dialogConf);

    ref.afterClosed.subscribe((result: CustomerRow) => {
      if (result != null) {
        this.worklog.payerId = result.id;
        this.worklog.payerCode = result.code;
      }
    });
  }

  public openIssueModal() {
    if (this.worklog.customerId == null) {
      sweetAlert('Należy najpierw wybrać kontrahenta');
      return;
    }

    if (this.worklog.projectStepId == null) {
      sweetAlert('Należy najpierw wybrać etap prjektu');
      return;
    }
    let dialogConf = new DialogConfig();
    dialogConf.selectionMode = SelectionMode.single;
    dialogConf.title = 'Wybierz zgłoszenie';
    dialogConf.maxwidth = '1000px';
    dialogConf.data = { projectStepId: this.worklog.projectStepId, initialFilters: { fullTitle: this.worklog.issueName } };
    const ref = this.dialog.open(IssuesListComponent, dialogConf);
    ref.afterClosed.subscribe((result: IssueRow) => {
      if (result != null) {
        this.worklog.issueId = result.id;
        this.worklog.issueName = result.fullTitle;
      }
    });
  }

  private checkSaveCondition() {
    if (this.worklog.issueName && this.worklog.issueName.length > 0 && this.worklog.issueId == null) {
      return false;
    }
    if (!this.invoiceTime.isValid) {
      return false;
    }
    if (!this.timeSpent.isValid) {
      return false;
    }
    return true;
  }

  public isInvalid() {
    if (this.checkSaveCondition()) {
      return this.worklogForm.invalid;
    }
    return true;
  }

  public buildDescription() {
    if (this.employeesRows && this.employeesRows.some(x => x.id === this.worklog.reporterId)) {
      this.worklog.description = this.employeesRows.find(x => x.id === this.worklog.reporterId).name.split(' (')[0] + ': Realizacja zgłoszenia #' + this.worklog.issueId.toString();
    }
  }


  private getCustomerProjectSteps(customerId: number) {
    const action = this.projRest.getCustomerProjectStepsForWorklog;
    action.call(this.rest, customerId, this.worklog.id).subscribe((result: ObjectToSelect[]) => {
      if (result) {
        this.projectSteps = result;
        if (result.filter(x => x.id === this.worklog.projectStepId).length === 0) {
          this.worklog.projectStepId = null;
          this.worklog.projectStepName = '';
        }
      }
    });
  }

  private searchCallback(search: string, item: INgxSelectOption): boolean {
    search = search.toLowerCase();
    return item.data.name.toLowerCase().includes(search) || item.data.guid.toLowerCase().includes(search);
  }

  private removeRelatedIssue() {
    if (this.fromIssue)
      return;

    this.worklog.issueId = null;
    this.worklog.issueName = null;
  }
}

